import { useEffect, useState } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';

import DataTableSearch from './DataTableSearch';
import DataTableTable from './DataTableTable';
import DataTableCards from './DataTableCards';
import DataTablePaginate from './DataTablePaginate';

type ClassificacaoData = {
	id: number;
	id_sub: number;
	nome: string;
	prod_visible: boolean;
	status: string;
}
type ProdutoData = {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  url_imagem: string;
  id_classif: number;
	valor: number;
	total: number;
	valorFormatted: string;
	totalFormatted: string;
}
interface DataTableClienteParams {
  data: ProdutoData[];
	// classificacoes: ClassificacaoData[];
	setClassifModal: (classif: ClassificacaoData) => void;
	setProdutoModal: (product: ProdutoData) => void;
	setModalPausarAtivarVisible: (visible: boolean) => void;
	setModalProdutoVisible: (visible: boolean) => void;
	handleFindClassif: (classif: string) => void;
}

const DataTableProducts: React.FC<DataTableClienteParams> = ({ 
	data,
	// classificacoes,
	setClassifModal,
	setProdutoModal,
	setModalPausarAtivarVisible,
	setModalProdutoVisible,
	handleFindClassif,
}) => {
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const [loading, setLoading] = useState(true);

  const [pesqProdutos, setPesqProdutos] = useState<ProdutoData[]>(data);
  const [produtos, setProdutos] = useState<ProdutoData[]>(data);

  const [sort, setSort] = useState({ por: '', cres: true });

  const [controls, setControls] = useState({
    page: 1,
    perPage: 10,
    totalPage: Math.ceil(data.length / 10),
  });

  useEffect(() => {
    setProdutos(data.slice(0, 10));
    setLoading(false);
  }, []);

  async function handleUpdateList(
    page: number,
    perPage: number,
    prods: ProdutoData[],
  ) {
    const auxPage = page - 1;
    const start = auxPage * perPage;
    const end = start + perPage;

    setProdutos(prods.slice(start, end));
  }

  return (
    <Flex w="100%" flexDir="column">
      <DataTableSearch
        produtos={data}
        setPesqProdutos={setPesqProdutos}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />

      {isWideVersion && (
        <DataTableTable
          produtos={produtos}
          pesqProdutos={pesqProdutos}
          sort={sort}
          setSort={setSort}
          controls={controls}
          handleUpdateList={handleUpdateList}
					setClassifModal={setClassifModal}
					setProdutoModal={setProdutoModal}
					setModalPausarAtivarVisible={setModalPausarAtivarVisible}
					setModalProdutoVisible={setModalProdutoVisible}
					handleFindClassif={handleFindClassif}
        />
      )}

      {!isWideVersion && !loading && (
				<DataTableCards
					produtos={produtos}
					setClassifModal={setClassifModal}
					setProdutoModal={setProdutoModal}
					setModalPausarAtivarVisible={setModalPausarAtivarVisible}
					setModalProdutoVisible={setModalProdutoVisible}
					handleFindClassif={handleFindClassif}
				/>
			)}

      <DataTablePaginate
        prod_length={data.length}
        pesq_length={pesqProdutos.length}
        pesqProdutos={pesqProdutos}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />
    </Flex>
  );
};

export default DataTableProducts;
